import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`@add-on-hlapi-sdk`}</p>
    <h1 {...{
      "id": "add-on-hlapi-sdk"
    }}>{`@add-on-hlapi-sdk`}</h1>
    <h2 {...{
      "id": "table-of-contents"
    }}>{`Table of contents`}</h2>
    <h3 {...{
      "id": "namespaces"
    }}>{`Namespaces`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "modules/Constants.md"
        }}>{`Constants`}</a></li>
    </ul>
    <h3 {...{
      "id": "enumerations"
    }}>{`Enumerations`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "enums/ArrowHeadType.md"
        }}>{`ArrowHeadType`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "enums/BlendModeValue.md"
        }}>{`BlendModeValue`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "enums/ColorSpace.md"
        }}>{`ColorSpace`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "enums/FillTypeValue.md"
        }}>{`FillTypeValue`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "enums/SceneNodeTypeValueID.md"
        }}>{`SceneNodeTypeValueID`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "enums/StrokePositionValue.md"
        }}>{`StrokePositionValue`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "enums/TextAlignmentValue.md"
        }}>{`TextAlignmentValue`}</a></li>
    </ul>
    <h3 {...{
      "id": "classes"
    }}>{`Classes`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "classes/ArtboardList.md"
        }}>{`ArtboardList`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "classes/ArtboardNode.md"
        }}>{`ArtboardNode`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "classes/Color.md"
        }}>{`Color`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "classes/ContainerNode.md"
        }}>{`ContainerNode`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "classes/Context.md"
        }}>{`Context`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "classes/Editor.md"
        }}>{`Editor`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "classes/EllipseNode.md"
        }}>{`EllipseNode`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "classes/ExpressRootNode.md"
        }}>{`ExpressRootNode`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "classes/FillableNode.md"
        }}>{`FillableNode`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "classes/GroupNode.md"
        }}>{`GroupNode`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "classes/ImageRectangleNode.md"
        }}>{`ImageRectangleNode`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "classes/ItemList.md"
        }}>{`ItemList`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "classes/LineNode.md"
        }}>{`LineNode`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "classes/MediaContainerNode.md"
        }}>{`MediaContainerNode`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "classes/Node.md"
        }}>{`Node`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "classes/PageList.md"
        }}>{`PageList`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "classes/PageNode.md"
        }}>{`PageNode`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "classes/ReadOnlyItemList.md"
        }}>{`ReadOnlyItemList`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "classes/RectangleNode.md"
        }}>{`RectangleNode`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "classes/StrokableNode.md"
        }}>{`StrokableNode`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "classes/TextNode.md"
        }}>{`TextNode`}</a></li>
    </ul>
    <h3 {...{
      "id": "interfaces"
    }}>{`Interfaces`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "interfaces/BitmapImage.md"
        }}>{`BitmapImage`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "interfaces/ColorFill.md"
        }}>{`ColorFill`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "interfaces/Fill.md"
        }}>{`Fill`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "interfaces/IFillableNode.md"
        }}>{`IFillableNode`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "interfaces/IRectangularNode.md"
        }}>{`IRectangularNode`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "interfaces/IStrokableNode.md"
        }}>{`IStrokableNode`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "interfaces/ListItem.md"
        }}>{`ListItem`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "interfaces/RectangleGeometry.md"
        }}>{`RectangleGeometry`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "interfaces/Stroke.md"
        }}>{`Stroke`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "interfaces/StrokeOptions.md"
        }}>{`StrokeOptions`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "interfaces/Utils.md"
        }}>{`Utils`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      